import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: '2020',
    loadChildren: () => import('./y2020/y2020.module')
      .then(m => m.Y2020Module)
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./y2021/y2021.module')
      .then(m => m.Y2021Module)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventRoutingModule {
}
